import type { SecondaryWeaponAttackConfig } from 'game/core'

export const secondary_weapon_attack_config: Array<SecondaryWeaponAttackConfig> = [
    {
        available: 0,
        energy: 'unknown',
        cooldown: 1
    }
]